<div class="dental-disability-memo-container" *ngIf="isDialogOpened">

  <!-- Header -->
  <!-- <div class="memo-header">
    <div class="header-title">
      <h3>牙科身障患者治療註記</h3>
    </div>
  </div> -->

  <!-- 患者資訊 -->
  <div class="patient-info-section">
    <div class="info-row">
      <div class="info-item">
        <label i18n="@@PatientNo">病歷號</label>
        <span class="info-value">{{ memoData.patientNo }}</span>
      </div>
      <div class="info-item">
        <label i18n="@@PatientName">患者姓名</label>
        <span class="info-value">{{ memoData.patientName }}</span>
      </div>
      <div class="info-item">
        <label i18n="@@PatientCId">身分證號</label>
        <span class="info-value">{{ memoData.patientCId }}</span>
      </div>
    </div>
  </div>

  <!-- 主要內容表單 -->
  <div class="memo-content-section" [ngClass]="{'edit-mode': isEditMode}">
    <!-- 證明文件圖片上傳區 -->
    <div class="form-group">
      <label class="form-label" i18n="@@DisabilityProofImages">身障證明文件</label>
      <div class="image-upload-container">
        <!-- 左側圖片 -->
        <div class="image-upload-box"
          [ngClass]="{'dragging': isDraggingLeft, 'has-image': leftImagePreview, 'disabled': !isEditMode}"
          (dragover)="onDragOver($event, 'left')"
          (dragleave)="onDragLeave($event, 'left')"
          (drop)="onDrop($event, 'left')"
          (click)="onImageClick('left')">
          <div class="image-preview" *ngIf="leftImagePreview">
            <img [src]="leftImagePreview" alt="證明文件正面">
            <button type="button" class="remove-image-btn" *ngIf="isEditMode"
              (click)="removeImage('left', $event)" title="移除圖片">
              <span>×</span>
            </button>
          </div>
          <div class="upload-placeholder" *ngIf="!leftImagePreview">
            <div class="upload-icon">📷</div>
            <div class="upload-text" *ngIf="isEditMode">
              <p>點擊或拖曳上傳</p>
              <p class="upload-hint">證明文件正面</p>
            </div>
            <div class="upload-text" *ngIf="!isEditMode">
              <p class="upload-hint">無圖片</p>
            </div>
          </div>
        </div>

        <!-- 右側圖片 -->
        <div class="image-upload-box"
          [ngClass]="{'dragging': isDraggingRight, 'has-image': rightImagePreview, 'disabled': !isEditMode}"
          (dragover)="onDragOver($event, 'right')"
          (dragleave)="onDragLeave($event, 'right')"
          (drop)="onDrop($event, 'right')"
          (click)="onImageClick('right')">
          <div class="image-preview" *ngIf="rightImagePreview">
            <img [src]="rightImagePreview" alt="證明文件背面">
            <button type="button" class="remove-image-btn" *ngIf="isEditMode"
              (click)="removeImage('right', $event)" title="移除圖片">
              <span>×</span>
            </button>
          </div>
          <div class="upload-placeholder" *ngIf="!rightImagePreview">
            <div class="upload-icon">📷</div>
            <div class="upload-text" *ngIf="isEditMode">
              <p>點擊或拖曳上傳</p>
              <p class="upload-hint">證明文件背面</p>
            </div>
            <div class="upload-text" *ngIf="!isEditMode">
              <p class="upload-hint">無圖片</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 身心障礙類別表格 -->
    <div class="form-group">
      <label class="form-label" i18n="@@DisabilityCategory">身心障礙類別</label>
      <div class="quick-select-bar">
        <div class="quick-tag" *ngFor="let tag of quickSelectTags; let idx = index">
          <span class="quick-tag-text">{{ tag.display }}</span>
          <button type="button" class="quick-tag-remove" (click)="removeQuickTag(idx)" [disabled]="!isEditMode">×</button>
        </div>
        <div class="quick-input" [class.disabled]="!isEditMode">
          <div
            #quickSelectBox
            class="quick-input-box"
            [attr.contenteditable]="isEditMode"
            [attr.placeholder]="''"
            data-placeholder="🔍關鍵字快選"
            (keydown)="handleQuickSelectKeydown($event)"
            (input)="handleQuickSelectInput($event)"></div>
        </div>
      </div>
      <div class="disability-table">
        <div class="table-header">
          <div class="col-new-category">新制類別（8類）</div>
          <div class="col-old-category">舊制類別（16類）</div>
          <div class="col-severity">嚴重程度（<span class="severity-highlight">適用16案類</span>）</div>
        </div>

        <div class="table-body">
          <ng-container *ngFor="let row of disabilityRows; let i = index">
            <div class="table-row" *ngIf="shouldShowRow(row)">
            <!-- 新制類別 -->
            <div class="col-new-category">
              <label class="checkbox-label" *ngIf="i === 0">
                <input type="checkbox"
                  [checked]="newDisabilityCategories[0].checked"
                  [disabled]="!isEditMode"
                  (change)="newDisabilityCategories[0].checked = !newDisabilityCategories[0].checked; onNewCategoryChange(newDisabilityCategories[0])"
                  class="checkbox-input">
                <span class="checkbox-text">{{ newDisabilityCategories[0].name }}</span>
              </label>
              <label class="checkbox-label" *ngIf="i === 1">
                <input type="checkbox"
                  [checked]="newDisabilityCategories[1].checked"
                  [disabled]="!isEditMode"
                  (change)="newDisabilityCategories[1].checked = !newDisabilityCategories[1].checked; onNewCategoryChange(newDisabilityCategories[1])"
                  class="checkbox-input">
                <span class="checkbox-text">{{ newDisabilityCategories[1].name }}</span>
              </label>
              <label class="checkbox-label" *ngIf="i === 2">
                <input type="checkbox"
                  [checked]="newDisabilityCategories[2].checked"
                  [disabled]="!isEditMode"
                  (change)="newDisabilityCategories[2].checked = !newDisabilityCategories[2].checked; onNewCategoryChange(newDisabilityCategories[2])"
                  class="checkbox-input">
                <span class="checkbox-text">{{ newDisabilityCategories[2].name }}</span>
              </label>
              <label class="checkbox-label" *ngIf="i === 3">
                <input type="checkbox"
                  [checked]="newDisabilityCategories[3].checked"
                  [disabled]="!isEditMode"
                  (change)="newDisabilityCategories[3].checked = !newDisabilityCategories[3].checked; onNewCategoryChange(newDisabilityCategories[3])"
                  class="checkbox-input">
                <span class="checkbox-text">{{ newDisabilityCategories[3].name }}</span>
              </label>
              <label class="checkbox-label" *ngIf="i === 4">
                <input type="checkbox"
                  [checked]="newDisabilityCategories[4].checked"
                  [disabled]="!isEditMode"
                  (change)="newDisabilityCategories[4].checked = !newDisabilityCategories[4].checked; onNewCategoryChange(newDisabilityCategories[4])"
                  class="checkbox-input">
                <span class="checkbox-text">{{ newDisabilityCategories[4].name }}</span>
              </label>
              <label class="checkbox-label" *ngIf="i === 5">
                <input type="checkbox"
                  [checked]="newDisabilityCategories[5].checked"
                  [disabled]="!isEditMode"
                  (change)="newDisabilityCategories[5].checked = !newDisabilityCategories[5].checked; onNewCategoryChange(newDisabilityCategories[5])"
                  class="checkbox-input">
                <span class="checkbox-text">{{ newDisabilityCategories[5].name }}</span>
              </label>
              <label class="checkbox-label" *ngIf="i === 6">
                <input type="checkbox"
                  [checked]="newDisabilityCategories[6].checked"
                  [disabled]="!isEditMode"
                  (change)="newDisabilityCategories[6].checked = !newDisabilityCategories[6].checked; onNewCategoryChange(newDisabilityCategories[6])"
                  class="checkbox-input">
                <span class="checkbox-text">{{ newDisabilityCategories[6].name }}</span>
              </label>
              <label class="checkbox-label" *ngIf="i === 7">
                <input type="checkbox"
                  [checked]="newDisabilityCategories[7].checked"
                  [disabled]="!isEditMode"
                  (change)="newDisabilityCategories[7].checked = !newDisabilityCategories[7].checked; onNewCategoryChange(newDisabilityCategories[7])"
                  class="checkbox-input">
                <span class="checkbox-text">{{ newDisabilityCategories[7].name }}</span>
              </label>
              <label class="checkbox-label" *ngIf="i === 8">
                <input type="checkbox"
                  [checked]="newDisabilityCategories[8].checked"
                  [disabled]="!isEditMode"
                  (change)="newDisabilityCategories[8].checked = !newDisabilityCategories[8].checked; onNewCategoryChange(newDisabilityCategories[8])"
                  class="checkbox-input">
                <span class="checkbox-text">{{ newDisabilityCategories[8].name }}</span>
              </label>
              <label class="checkbox-label" *ngIf="i === 9">
                <input type="checkbox"
                  [checked]="newDisabilityCategories[9].checked"
                  [disabled]="!isEditMode"
                  (change)="newDisabilityCategories[9].checked = !newDisabilityCategories[9].checked; onNewCategoryChange(newDisabilityCategories[9])"
                  class="checkbox-input">
                <span class="checkbox-text">{{ newDisabilityCategories[9].name }}</span>
              </label>
            </div>

            <!-- 舊制類別 -->
            <div class="col-old-category">
              <ng-container *ngFor="let item of row.items">
                <!-- 代碼 13：自動計算，不顯示勾選框 -->
                <div class="code-13-display" *ngIf="isCode13Item(item)">
                  <span class="code-13-label">{{ item.name }}</span>
                  <span class="code-13-badge" *ngIf="getCode13AutoSeverity()">
                    ({{ getCode13AutoSeverityLabel() }})
                  </span>
                  <span class="code-13-badge" *ngIf="!getCode13AutoSeverity()">
                    (無多重障礙)
                  </span>
                </div>

                <!-- 代碼 15、16：手動選擇 -->
                <label class="checkbox-label" *ngIf="isManualSelectItem(item) && shouldShowOldCategoryItem(item)">
                  <input type="checkbox"
                    [checked]="item.checked"
                    [disabled]="!isEditMode || isItemDisabled(item)"
                    (change)="item.checked = !item.checked; onOldCategoryChange(item)"
                    class="checkbox-input">
                  <span class="checkbox-text">{{ item.name }}</span>
                </label>

                <!-- 其他代碼：一般勾選 -->
                <label class="checkbox-label" *ngIf="!isCode13Item(item) && !isManualSelectItem(item) && shouldShowOldCategoryItem(item)">
                  <input type="checkbox"
                    [checked]="item.checked"
                    [disabled]="!isEditMode || isItemDisabled(item)"
                    (change)="item.checked = !item.checked; onOldCategoryChange(item)"
                    class="checkbox-input">
                  <span class="checkbox-text">{{ item.name }}</span>
                </label>
              </ng-container>
            </div>

            <!-- 嚴重程度 -->
            <div class="col-severity">
              <ng-container *ngFor="let item of row.items">
                <!-- 代碼 13：顯示自動計算的嚴重度（唯讀）-->
                <div class="severity-group code-13-severity" *ngIf="isCode13Item(item)">
                  <span class="readonly-badge" *ngIf="getCode13AutoSeverity()">
                    {{ getCode13AutoSeverityLabel() }}
                  </span>
                  <span class="readonly-badge empty" *ngIf="!getCode13AutoSeverity()">
                    --
                  </span>
                </div>

                <!-- 代碼 15、16、其他：可選擇嚴重度 -->
                <div class="severity-group" *ngIf="!isCode13Item(item) && shouldShowOldCategoryItem(item)">
                  <label class="radio-label"
                    *ngFor="let severity of getSeverityOptionsForItem(item)"
                    [ngClass]="{'severity-highlight': isSeverityHighlighted(item, severity.value), 'severity-placeholder': isSeverityPlaceholder(item, severity.value)}">
                    <ng-container *ngIf="!isSeverityPlaceholder(item, severity.value); else severityPlaceholder">
                      <input type="radio"
                        [value]="severity.value"
                        [checked]="item.severityLevel === severity.value"
                        [disabled]="!isEditMode || isItemDisabled(item)"
                        (change)="onSeverityChange(item, severity.value)"
                        class="radio-input"
                        [attr.name]="'severity_' + item.code">
                      <span class="radio-text">{{ severity.label }}</span>
                    </ng-container>
                    <ng-template #severityPlaceholder>
                      <span class="radio-text">&nbsp;</span>
                    </ng-template>
                  </label>
                </div>
              </ng-container>
            </div>
          </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- 額外特殊需求 -->
    <div class="form-group">
      <label class="form-label" i18n="@@TreatmentItems">治療特殊需求</label>
      <div class="treatment-items-wrapper">
        <div class="treatment-item" *ngFor="let item of treatmentItemsList">
          <label class="checkbox-label">
            <input type="checkbox"
              [(ngModel)]="item.checked"
              [disabled]="!isEditMode"
              class="checkbox-input">
            <span class="checkbox-text">{{ item.text }}</span>
          </label>
        </div>
      </div>
    </div>

    <!-- 特殊註記 -->
    <div class="form-group">
      <label class="form-label" i18n="@@Memo">綜合治療註記</label>
      <div class="form-control-wrapper">
        <textarea class="form-control textarea-control"
          [(ngModel)]="histRcd.Patient.Remark"
          [disabled]="!isEditMode"
          rows="6"
          placeholder="記錄患者的治療狀況、過往治療經驗、行為特徵等重要信息"
          i18n-placeholder="@@MemoPlaceholder"></textarea>
      </div>
    </div>

    <!-- Timestamp Info -->
    <div class="timestamp-info" *ngIf="memoData.createdDate || memoData.modifiedDate">
      <div class="timestamp-item" *ngIf="memoData.createdDate">
        <span class="timestamp-label" i18n="@@CreatedDate">建檔日期</span>
        <span class="timestamp-value">{{ memoData.createdDate | date:'yyyy-MM-dd HH:mm' }}</span>
      </div>
      <div class="timestamp-item" *ngIf="memoData.modifiedDate">
        <span class="timestamp-label" i18n="@@ModifiedDate">修改日期</span>
        <span class="timestamp-value">{{ memoData.modifiedDate | date:'yyyy-MM-dd HH:mm' }}</span>
      </div>
    </div>

  </div>

  <!-- Footer with Mode Selector and Action Buttons -->
  <div class="memo-footer">
    <!-- 醫療型態 -->
    <div class="footer-item service-mode-item">
      <label class="footer-label">醫療型態</label>
      <div class="service-mode-selector">
        <label class="radio-label" *ngFor="let mode of serviceModeOptions">
          <input type="radio"
            [value]="mode.value"
            [(ngModel)]="selectedServiceMode"
            (change)="onServiceModeChange()"
            [disabled]="!isEditMode || mode.disabled"
            class="radio-input">
          <span class="radio-text">{{ mode.label }}</span>
        </label>
      </div>
    </div>

    <!-- 符合的特殊治療項目代號 -->
    <div class="footer-item treatment-codes-item" *ngIf="matchedTreatmentItem">
      <label class="footer-label">特殊治療代號</label>
      <div class="treatment-codes-preview">
        <div class="codes-content">
          {{ matchedTreatmentItem }}
        </div>
      </div>
    </div>

    <!-- 符合的障礙別代碼 -->
    <div class="footer-item disability-type-codes-item" *ngIf="matchedDisabilityTypeCodes">
      <label class="footer-label">障礙別代碼</label>
      <div class="disability-type-codes-preview">
        <div class="codes-content">
          {{ matchedDisabilityTypeCodes }}
        </div>
      </div>
    </div>

    <!-- 置底按鈕 -->
    <div class="footer-item footer-buttons">
      <button type="button"
        class="btn-primary"
        (click)="isEditMode ? saveMemo() : toggleEditMode()"
        [disabled]="isSaving"
        i18n="@@Save">
        {{ isEditMode ? (isSaving ? '儲存中...' : '確定') : '編輯' }}
      </button>
      <button type="button"
        class="btn-secondary"
        (click)="isEditMode ? cancelEdit() : closeDialog()"
        [disabled]="isSaving"
        i18n="@@Cancel">{{ isEditMode ? '取消' : '關閉' }}</button>
      <button type="button"
        class="btn-danger"
        (click)="clearForm()"
        [disabled]="!isEditMode || isSaving"
        i18n="@@Clear">清除表單</button>
    </div>
  </div>

</div>
